import { pdf } from '@react-pdf/renderer';
import LabelPDFDocument from './LabelPdf';
import middleware from '../Api/Middleware';
import ToastPromise from '../Toasts/ToastPromise';

/**
 * Genereert PDF-labels voor de opgegeven product IDs.
 * @param {int[]} productIds - Een array met alle product IDs.
 * @returns {Promise<boolean>}
 */
export const generateLabel = async (productIds) => {
  const labelGenerationPromise = async () => {
    let formattedProductIds = productIds.map((id) => {
      return {
        product_id: id,
      };
    });

    const response = await middleware.get(`products/labels`, {
      params: {
        products: formattedProductIds,
      },
    });

    if (!window.Buffer) {
      const { Buffer } = await import('buffer');
      window.Buffer = Buffer;
    }

    // Generate PDF
    const pdfDoc = (
      <LabelPDFDocument products={response.data.data.products} template={response.data.data.template} />
    );

    const pdfBlob = await pdf(pdfDoc).toBlob();

    // Create object URL for the PDF
    const url = URL.createObjectURL(pdfBlob);

    return { url, products: response.data.data.products };
  };

  try {
    const result = await ToastPromise({
      promise: labelGenerationPromise(),
      pending: 'Labels genereren...',
      successRenderer: (data) => `${data.products.length} label(s) gegenereerd!`,
      errorRenderer: (error) => `Fout bij genereren labels: ${error?.message || 'Onbekende fout'}`,
      autoClose: 3000,
    });

    if (result?.url) {
      // Open PDF in new window/tab and trigger print (after toast success)
      const printWindow = window.open(result.url, '_blank');
      
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    }

    return true;
  } catch (error) {
    console.error('Error generating label:', error);
    return false;
  }
};

export default generateLabel;